export enum PermissionType {
  Allow = 'allow',
  Deny = 'deny',
}
